<div [class]="containerClass">
    <mat-form-field [class]="fieldClass">
        <mat-label appRemoveAriaOwns>{{ firstDayOfPeriodLabel | translate }} </mat-label>
        <mat-select
            required
            name="startOfWeek"
            #startOfWeek
            [(ngModel)]="timeOffPolicy.startOfWeek"
            placeholder="{{ firstDayOfPeriodLabel | translate }}"
            (selectionChange)="getBiWeeklyAnchorDates($event.value)"
        >
            <mat-option *ngFor="let day of listOfWeekdays" [value]="day">
                <span translate="time-off-v3.policyComponents.accrualCard.{{ day }}"> </span
            ></mat-option>
        </mat-select>
    </mat-form-field>
</div>

<div class="app-grid">
    <mat-form-field [class]="fieldClass">
        <mat-label appRemoveAriaOwns>{{
            'time-off-v3.whichWeekValue' | translate: { week: startOfWeek?.triggerValue }
        }}</mat-label>
        <mat-select
            name="Which Week"
            placeholder="{{ 'time-off-v3.whichWeek' | translate }}"
            [(ngModel)]="timeOffPolicy.weeklyFrequenciesAnchor"
            (selectionChange)="previewDataChanged()"
            required
        >
            <mat-option *ngFor="let interval of biWeeklyAnchorDates" [value]="interval.value">{{
                interval.label
            }}</mat-option>
        </mat-select>
    </mat-form-field>
</div>
